var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31479 0H9.2593C10.5382 0 11.5741 1.27893 11.5741 2.3148V7.40751C11.5741 8.68644 10.5382 9.72231 9.2593 9.72231H2.31479C1.03587 9.72231 0 8.44339 0 7.40751V2.3148C0 1.03588 1.03587 0 2.31479 0Z",
    fill: "url(#paint0_linear_3536_20526)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7407 15.2777H22.6852C23.9641 15.2777 25 16.5566 25 17.5925V22.6852C25 23.9641 23.9641 25 22.6852 25H15.7407C14.4618 25 13.4259 23.7211 13.4259 22.6852V17.5925C13.4259 16.3136 14.4618 15.2777 15.7407 15.2777Z",
    fill: "url(#paint1_linear_3536_20526)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7407 0H22.6852C23.9641 0 25 1.27893 25 2.3148V11.1112C25 12.3901 23.9641 13.426 22.6852 13.426H15.7407C14.4618 13.426 13.4259 12.1471 13.4259 11.1112V2.3148C13.4259 1.03588 14.4618 0 15.7407 0Z",
    fill: "url(#paint2_linear_3536_20526)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31479 11.574H9.2593C10.5382 11.574 11.5741 12.8529 11.5741 13.8888V22.6852C11.5741 23.9641 10.5382 25 9.2593 25H2.31479C1.03587 25 0 23.7211 0 22.6852V13.8888C0 12.6099 1.03587 11.574 2.31479 11.574Z",
    fill: "url(#paint3_linear_3536_20526)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3536_20526",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3536_20526",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3536_20526",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3536_20526",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSubscription);
export default __webpack_public_path__ + "static/media/Manage Subscription.344bff9ed7b189060ba135ce24f79e5b.svg";
export { ForwardRef as ReactComponent };